import { Component, OnInit } from '@angular/core';
import { TenantsService } from '../../core/services/tenants.service';
import { CommonModule } from '@angular/common';
import { NSHeadermenuComponent } from '../../Clients/NS/Components/NS-headermenu/NS-headermenu.component';

@Component({
  selector: 'app-headermenu',
  standalone: true,
  imports: [CommonModule, NSHeadermenuComponent],
  templateUrl: './headermenu.component.html',
  styleUrl: './headermenu.component.scss',
})
export class HeadermenuComponent implements OnInit {
  tenantid: string = 'default';
  constructor(private TenantsService: TenantsService) {}
  ngOnInit(): void {
    this.tenantid = this.TenantsService.getTenantFromSubdomain();
    console.log('tenantid', this.tenantid);
  }
}
